/**
 * Which item "Add Linked" should link the next capture to.
 *
 * Pressing Add Linked on a card means "another one of THIS", and the newest item is the
 * closest referent — so the seed is the last linkable item, never nothing. The picker is
 * the correction, not the default: the seeded target shows in ObservationCapture's link row and
 * clears in one click, so a wrong guess costs one click and a right guess costs zero.
 *
 * Undefined only when the card holds no linkable item at all, which is also when callers
 * hide the button.
 */
export function resolveLinkSeed(
  items: readonly { remoteId?: number }[]
): number | undefined {
  for (let index = items.length - 1; index >= 0; index -= 1) {
    const remoteId = items[index].remoteId;
    if (typeof remoteId === 'number') return remoteId;
  }
  return undefined;
}
